import { Card, CompartmentCard } from "@/src/components/cards";
import { openConfirmDialog } from "@/src/components/dialogs";
import { ListConstructor } from "@/src/components/fetchableLists";
import {
  ChartPropertiesType,
  PediatricsRechartChart,
} from "@/src/components/pediatricsRechart";
import { RechartChart } from "@/src/components/rechartChart";
import {
  FieldOption,
  FolderItem,
  Patient,
  Reference,
} from "@/src/data/allTypes";
import { pediatricsChartData } from "@/src/data/pediatricsChartData";

import apiFetch from "@/src/utils/apiFetch";
import { getUserShortName, jsonAbstract, uid } from "@/src/utils/utils";
import { useQuery } from "@tanstack/react-query";
import { ChartDataset } from "chart.js";
import moment from "moment";
import { useState } from "react";
import { Chart } from "react-chartjs-2";

function MesureChartDrawer({
  patient,
  parent,
  reference,
  showMesuresList = true,
  additionalHtml,
}: {
  patient: Patient;
  parent: FolderItem | null | undefined;
  reference: Reference;
  showMesuresList?: boolean;
  additionalHtml?: React.ReactNode;
}) {
  const [reload, setReload] = useState(0);
  let { data, isLoading, isError, error, refetch } = useQuery({
    queryKey: ["MesureChartDrawer", patient.id, reference.id, reload],
    queryFn: () =>
      apiFetch("patientMesures", "loadPatientMesures", {
        patientId: patient.id,
        start: parent?._date,
        referenceId: reference.id,
      }),
  });

  // function generateDatasets() {
  //   if (!data) return [];
  //   let sets: Record<
  //     string,
  //     ChartDataset<"line", { x: Date; y: number }[]>
  //   > = {};
  //   for (let mesure of data) {
  //     for (let answer of mesure.fieldAnswers || []) {
  //       let fieldId = answer?.field?.id;
  //       if (!fieldId) continue;

  //       sets[fieldId] ||= {
  //         fill: true,
  //         label: mesure.reference?.name || "",
  //         data: [],
  //         borderColor: "rgb(255, 99, 132)",
  //         backgroundColor: "rgb(255, 99, 132,0.5)",
  //         tension: 0.4,
  //       };

  //       sets[fieldId].data.push({
  //         x: moment(mesure._date).toDate(),
  //         y: answer?.value,
  //       });
  //     }
  //   }

  //   return Object.values(sets);
  // }


  // function get_pediatrics_datasets(): ChartDataset<
  //   "line",
  //   { x: Date; y: number }[]
  // >[] {
  //   let norms = get_pediatrics_norms();
  //   if (!norms) return [];
  //   let start = moment(patient.birth).format("YYYY-MM-DD 00:00:00");
  //   let months_age = moment().diff(patient.birth, "months");

  //   const indexed_norms: Record<
  //     any,
  //     {
  //       x: Date;
  //       y: number;
  //     }[]
  //   > = {
  //     "-3sd": [],
  //     "-2sd": [],
  //     "-1sd": [],
  //     mediane: [],
  //     "+1sd": [],
  //     "+2sd": [],
  //     "+3sd": [],
  //   };

  //   for (let element of jsonAbstract(norms)) {
  //     if (months_age < 30 && element.month > 40) continue;
  //     if (months_age < 60 && element.month > 70) continue;

  //     element.x = moment(start)
  //       .add(element.month, "months")
  //       .format("YYYY-MM-DD HH:mm:ss");
  //     indexed_norms[element.name] ||= [];
  //     indexed_norms[element.name].push(element);
  //   }

  //   const colors: Record<any, any> = {
  //     "-3sd": {
  //       color: "rgba(255, 56, 56, 0.7)",
  //     },
  //     "-2sd": {
  //       color: "rgba(255, 102, 0, 0.7)",
  //     },
  //     "-1sd": {
  //       color: "rgba(255, 165, 0, 0.7)",
  //     },
  //     mediane: {
  //       color: "rgba(11, 184, 43,0.8)",
  //     },
  //     "+1sd": {
  //       color: "rgba(255, 165, 0, 0.7)",
  //     },

  //     "+2sd": {
  //       color: "rgba(255, 102, 0, 0.7)",
  //     },
  //     "+3sd": {
  //       color: "rgba(255, 56, 56, 0.7)",
  //     },
  //   };

  //   let curves_datasets: ChartDataset<"line", { x: Date; y: number }[]>[] = [];

  //   for (let [norm_id, norm_data] of Object.entries(indexed_norms)) {
  //     let color = colors[norm_id] || {};

  //     curves_datasets.push({
  //       data: norm_data,
  //       fill: false,
  //       label: norm_id,
  //       pointRadius: 0,
  //       pointHoverRadius: 0,
  //       borderWidth: 1,
  //       backgroundColor: "transparent",
  //       pointBackgroundColor: color?.color || "rgba(255, 56, 56, 1)",
  //       borderColor: color?.color || "rgba(255, 56, 56, 1)",
  //     });
  //   }

  //   return curves_datasets;
  // }


  // let pediatricsDataSets = get_pediatrics_datasets();
  // let counts: Record<any, any> = {};
  // let months_age = moment().diff(patient.birth, "months");

  // function getMin() {
  //   if (pediatricsDataSets.length > 0) {
  //     let min = 1000;
  //     for (let dataset of pediatricsDataSets) {
  //       for (let data of dataset.data) {
  //         if (data.y < min) min = data.y;
  //       }
  //     }
  //     for (let mesure of data || []) {
  //       for (let answer of mesure.fieldAnswers || []) {
  //         let val = jsonAbstract(answer?.value);
  //         if (val && val < min) min = val;
  //       }
  //     }
  //     return parseInt(min?.toString() || "0");
  //   }
  //   let min = 0;
  //   for (let section of reference.sections || []) {
  //     for (let field of section?.fields || []) {
  //       if (!field) continue;
  //       if (field.type != "number") continue;
  //       if (field.min && field.min < min) min = field.min;
  //     }
  //   }
  //   for (let mesure of data || []) {
  //     for (let answer of mesure.fieldAnswers || []) {
  //       let val = jsonAbstract(answer?.value);
  //       if (val && val < min) min = val;
  //     }
  //   }

  //   return parseInt(min?.toString() || "0");
  // }

  // function getMax() {
  //   if (pediatricsDataSets.length > 0) {
  //     let max = 0;
  //     for (let dataset of pediatricsDataSets) {
  //       for (let data of dataset.data) {
  //         if (data.y > max) max = data.y;
  //       }
  //     }
  //     for (let mesure of data || []) {
  //       for (let answer of mesure.fieldAnswers || []) {
  //         let val = jsonAbstract(answer?.value);
  //         if (val && val > max) max = val;
  //       }
  //     }
  //     return parseInt(max?.toString() || "0");
  //   }
  //   let max = 0;
  //   for (let section of reference.sections || []) {
  //     for (let field of section?.fields || []) {
  //       if (!field) continue;
  //       if (field.type != "number") continue;
  //       if (field.max && field.max > max) max = field.max;
  //     }
  //   }
  //   for (let mesure of data || []) {
  //     for (let answer of mesure.fieldAnswers || []) {
  //       let val = jsonAbstract(answer?.value);
  //       if (val && val > max) max = val;
  //     }
  //   }
  //   if (max == 0) return undefined;
  //   return parseInt(max?.toString() || "0");
  // }

  
  function get_pediatrics_norms() {
    let age = moment().diff(patient.birth, "months");
    if (age > 200) return null;

    let name = reference.name
      ?.toLowerCase()
      .trim()
      .replace("é", "e")
      .replace("è", "e")
      .replace("â", "a");
    if (!name) return null;

    if (patient.sex == "femme") {
      if (name == "poids") return pediatricsChartData.girls_weight;
      if (name == "taille") return pediatricsChartData.girls_size;
      if (name == "perimetre cranien")
        return pediatricsChartData.girls_head_circumference;
    }

    if (name == "poids") return pediatricsChartData.boys_weight;
    if (name == "taille") return pediatricsChartData.boys_size;
    if (name == "perimetre cranien")
      return pediatricsChartData.boys_head_circumference;
    return null;
  }


  function get_pediatrics_rechart_datasets() {
    let norms = get_pediatrics_norms();

    let indexed_norms: Record<
      string,
      {
        x: any;
        y: number;
      }[]
    > = {};

    for (let mesure of data || []) {
      for (let answer of mesure.fieldAnswers || []) {
        let name = answer?.field?.name || mesure.reference?.name || "";
        indexed_norms[name] ||= [];
        indexed_norms[name].push({
          x: moment(mesure._date).diff(moment(patient.birth), "month"),
          y: parseFloat(answer?.value?.toString() || "0"),
        });
      }
    }

    indexed_norms = {
      ...indexed_norms,
      "+3sd": [],
      "+2sd": [],
      "+1sd": [],
      mediane: [],
      "-1sd": [],
      "-2sd": [],
      "-3sd": [],
    };

    for (let element of jsonAbstract(norms || [])) {
      element.x = element.month;
      indexed_norms[element.name] ||= [];
      indexed_norms[element.name].push(element);
    }

    return indexed_norms;
  }

  function generateSimpleDatasets() {
    let indexed_norms: Record<
      string,
      {
        x: any;
        y: number;
      }[]
    > = {};

    for (let mesure of data || []) {
      for (let answer of mesure.fieldAnswers || []) {
        let name = answer?.field?.name || mesure.reference?.name || "";
        indexed_norms[name] ||= [];
        indexed_norms[name].push({
          x: mesure._date,
          y: parseFloat(answer?.value?.toString() || "0"),
        });
      }
    }
    return indexed_norms;
  }

  function getChartsProperties() {
    const properties: Record<string, ChartPropertiesType> = {
      "-3sd": {
        color: "rgba(0,0,0, 0.4)",
        dot: false,
        strokeDasharray: "3 3",
      },
      "-2sd": { color: "rgba(0,0,0, 0.7)", dot: false },
      "-1sd": {
        color: "rgba(0,0,0, 1)",
        dot: false,
        strokeDasharray: "3 3",
      },
      mediane: { color: "rgba(0,0,0,0.8)", dot: false },
      "+1sd": {
        color: "rgba(0,0,0, 1)",
        dot: false,
        strokeDasharray: "3 3",
      },
      "+2sd": { color: "rgba(0,0,0, 0.7)", dot: false },
      "+3sd": {
        color: "rgba(0,0,0, 0.4)",
        dot: false,
        strokeDasharray: "3 3",
      },
    };

    for (let mesure of data || []) {
      for (let answer of mesure.fieldAnswers || []) {
        let name = answer?.field?.name || mesure.reference?.name || "";
        properties[name] = {
          color: "rgba(255, 56, 56, 1)",
          dot: true,
          strokeWidth: 5,
          showFill: true,
        };
      }
    }
    return properties;
  }

  function getValue(
    value: any,
    options: (FieldOption | null | undefined)[]
  ): any {
    if (Array.isArray(value)) return value.map((v) => getValue(v, options));
    let val = value?.id || value;
    let option = options?.find((option) => option?.id === val);
    return option?.name || val;
  }

  return (
    <ListConstructor
      data={data}
      isLoading={isLoading}
      isError={isError}
      error={error}
    >
      <div className="c1 gap20">
        <Card title={`${reference.name}`} className="empty" color="red">
          {/* {pediatricsDataSets.length == 0 ? (
            <Chart
              height={"200px"}
              type="line"
              options={{
                responsive: true,
                plugins: {
                  legend: {
                    position: "top" as const,
                  },
                  title: {
                    display: true,
                    text: "Chart.js Line Chart",
                  },
                },
                scales: {
                  x: {
                    type: "time",
                    // ticks: {
                    //   callback: function (value) {
                    //     return moment(value).format("LL HH:mm:ss");
                    //   },
                    // },
                  },
                  y: {
                    min: getMin(),
                    max: getMax(),

                    ticks: {
                      callback: function (value) {
                        return Number(value).toFixed(2); // Round to 2 decimal places
                      },
                    },
                  },
                },
              }}
              data={{
                datasets: generateDatasets(),
              }}
            />
          ) : ( */}
          <div className="c1 gap10 mtop20">
            {get_pediatrics_norms() != null && (
              <PediatricsRechartChart
                patient={patient}
                reference={reference}
                chartData={get_pediatrics_rechart_datasets()}
                chartsProperties={getChartsProperties()}
              />
            )}
            {get_pediatrics_norms() == null && (
              <RechartChart
                chartData={generateSimpleDatasets()}
                chartsProperties={getChartsProperties()}
              />
            )}
            {/* <Chart
              height={"200px"}
              type="line"
              options={{
                responsive: true,
                maintainAspectRatio: true,
                scales: {
                  x: {
                    type: "time",
                  },
                  y: {
                    min: getMin(),
                    max: getMax(),
                  },
                },
              }}
              data={{
                datasets: [...generateDatasets(), ...get_pediatrics_datasets()],
              }}
            /> */}
          </div>
          {/* )} */}
        </Card>
        {additionalHtml}
        {showMesuresList && (
          <CompartmentCard title="Mesures" color="red">
            <div className="c1 gap10">
              {data?.map((mesure) => {
                return (
                  <Card
                    key={mesure.id}
                    color="red"
                    title={moment(mesure._date).format("LL")}
                    trailing={
                      <div className="c1 gap5 right">
                        {mesure.fieldAnswers?.map((answer) => {
                          return (
                            <div key={uid()} className="bold">
                              {getValue(
                                answer?.value,
                                answer?.field?.options || []
                              )}{" "}
                              {answer?.field?.unit?.name || ""}
                            </div>
                          );
                        })}
                      </div>
                    }
                    onDelete={async () => {
                      await openConfirmDialog({
                        title: "Supprimer la mesure",
                        content:
                          "Êtes-vous sûr de vouloir supprimer cette mesure ?",
                        onConfirm: async () => {
                          await apiFetch("general", "deleteAny", {
                            id: mesure.id,
                            table: "refAnswers",
                          });
                          setReload((prev) => prev + 1);
                        },
                      });
                    }}
                  >
                    <div className="grid c1 gap5">
                      <div className="gray">
                        {getUserShortName(mesure.creator)}
                      </div>
                    </div>
                  </Card>
                );
              })}
            </div>
          </CompartmentCard>
        )}
      </div>
    </ListConstructor>
  );
}

export { MesureChartDrawer };
